import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { ReservationPendingListPage } from '../../reservation/reservation-pending-list/reservation-pending-list';
import { ReservationLoaderPage } from '../../reservation/reservation-loader/reservation-loader';
import { ReservationAcceptedListPage } from '../../reservation/reservation-accepted-list/reservation-accepted-list';
import { ReservationDeniedListPage } from '../../reservation/reservation-denied-list/reservation-denied-list';
import { Globals } from '../../../globals';
import { ReservationsServices } from '../../reservation/services';
import { AddonsTriggerVersionProPage } from '../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { ReservationConfig } from '../../reservation/reservation-config/reservation-config';

@Component({
  selector: 'page-top-reservations',
  templateUrl: 'top-reservations.html',
})
export class TopReservationsPage {
  @Input() type;
  number_pendings: number = 0;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public reservationsServices: ReservationsServices) {
    this.pendingReservations();
  }

  activeTab(value) {
    if (this.type == value) {
      let cssClasses = {
        'active': true,
        'nav-link': true,
        'space-norwap': true,
        'text-uppercase': true
      }
      return cssClasses;
    } else {
      let cssClasses = {
        'active': false,
        'nav-link': true,
        'space-norwap': true,
        'text-uppercase': true
      }
      return cssClasses;
    }
  }

  openCalendar() {
    if(this.globals.checkLimitsByLicense('reservations', 'calendar')) {
      this.navCtrl.push(ReservationLoaderPage);
    } else{
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }
  openPendingList() {
    if(this.globals.checkLimitsByLicense('reservations', 'calendar')) {
      this.navCtrl.push(ReservationPendingListPage);
    } else{
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }   }
  openAcceptedList() {
    this.navCtrl.push(ReservationAcceptedListPage);
  }
  openDeniedList() {
    this.navCtrl.push(ReservationDeniedListPage);
  }

  openConfig() {
    this.navCtrl.push(ReservationConfig);
  }
  async pendingReservations() {
    var pending_reservations = await this.reservationsServices.getReservationsByState(this.globals.restaurant_uid, 'pending');
    this.reservationsServices.number_pendings = pending_reservations.number_reservations;
  }

}



// WEBPACK FOOTER //
// ./src/pages/components/top-reservations/top-reservations.ts